module.exports = __webpack_public_path__ + "static/scale-model-of-magic-town-in-colorado-springs-colorado-4c59c18d346e0962f8a58cea3616c42c.png";